import Api from './api';

const getAllMailRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/gmail', {headers: { Authorization: 'Bearer ' + access_token }})
}

const getAllMailFromUserRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/gmail/' + id, {headers: { Authorization: 'Bearer ' + access_token }})
}

const getMailByIdRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/gmail/thread/' + id, {headers: { Authorization: 'Bearer ' + access_token }})
}

const sendReplyRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/gmail/reply', data, {headers: { Authorization: 'Bearer ' + access_token }})
}

export default { getAllMailRequest, getAllMailFromUserRequest, getMailByIdRequest, sendReplyRequest }



// WEBPACK FOOTER //
// ./src/api/apiGmail.js